import { Pipe, PipeTransform } from '@angular/core';
import { IRootState } from '@bca-store/store.reducers';
import { Store, select } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { IProduct } from '@bca-shared/models/product';
import { ProductIdentifier } from '@bca-shared/models/_enums';

@Pipe({ name: 'preSelected' })
export class PreSelectedPipe implements PipeTransform {
  constructor(private _store$: Store<IRootState>) {}

  transform(product: IProduct): Observable<boolean> {
    return this._store$.pipe(
      select(({ compose }) => compose),
      take(1),
      map(({ selectedProduct, configuredProduct, trainFreePrice }) => {
        const { identifier, price } = product;
        switch (identifier) {
          case ProductIdentifier.Traject: {
            const selected =
              selectedProduct == null &&
              configuredProduct != null &&
              configuredProduct.price < trainFreePrice;
            return selected;
          }
          case ProductIdentifier.TreinVrij: {
            const selected =
              selectedProduct == null &&
              configuredProduct != null &&
              configuredProduct.price >= price;
            return selected;
          }
          default: {
            return false;
          }
        }
      })
    );
  }
}
